import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PageState } from 'src/app/core/base-page';
import { MediaPath } from 'src/app/data/schema/cbs/media-path';

@Component({
  selector: 'app-media-library',
  templateUrl: './media-library.component.html',
  styleUrls: ['./media-library.component.scss'],
})
export class MediaLibraryComponent implements OnInit {
  
  images: MediaPath[] = [];

  selectedIdxs: number[] = [];

  maxImages: number = 5;
  alreadyAdded: string[] = []; // array of image paths already on entity

  busyState: PageState;

  constructor(private modalCtrl: ModalController) { 
    console.log('media library')
  }

  async ngOnInit() {
    this.images = await MediaPath.loadAll();
  }

  async imageAdded(base64: string){
    const newMedia = new MediaPath();
    await newMedia.uploadImg(base64);
    this.images.unshift(newMedia);
  }

  apply() {
    var selectedImgs = [];
    this.selectedIdxs.forEach(i => {
      selectedImgs.push(this.images[i]);
    })
    this.modalCtrl.dismiss({selectedImgs});
  }
  
  dismiss() {
    this.modalCtrl.dismiss();
  }

  select(idx) {
    if ( !this.selectedIdxs.includes(idx) ) {
      if ( this.alreadyAdded.length + this.selectedIdxs.length < this.maxImages)
      this.selectedIdxs.push(idx);
    } else { 
      this.selectedIdxs.splice(this.selectedIdxs.indexOf(idx), 1);
    }
  }

  async remove(idx: number) {
    var media = this.images[idx];
    if ( await media.delete(this.busyState) ) {
      this.images.splice(idx, 1);
    }
  }
}
